export enum RecipientStatus {
  VALID        = 'valid',
  UNAUTHORIZED = 'unauthorized',
  INVALID      = 'invalid'
}
